import { render, staticRenderFns } from "./SportsCover_c1.vue?vue&type=template&id=6600af34&"
import script from "./SportsCover_c1.vue?vue&type=script&lang=js&"
export * from "./SportsCover_c1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports